document.addEventListener('DOMContentLoaded', function () {
    const form = document.querySelector('form[action*="/cart/add"]')
    if (!form) return

    const variantSelect = form.querySelector('[name="id"]')
    const stockMessage = document.querySelector('#stock-message')
  
    // If either element is missing, exit to avoid errors
    if (!variantSelect || !stockMessage) return
  
    const availableLabel = stockMessage.querySelector('.stock-message-text.stock-available')
    const unavailableLabel = stockMessage.querySelector('.stock-message-text.stock-unavailable')
 
    // If either element is missing, exit to avoid errors
    if (!availableLabel || !unavailableLabel) return
  
    // Convert Liquid 'product' object into usable JavaScript object
    const product = window._themeProducts[meta.product.id]
 
    function updateStockMessage () {
      // Find which variant ID is currently selected
      const selectedVariantId = Number(variantSelect.value)
 
      // Look up that variant in the product’s variants array
      const selectedVariant = product.variants.find((variant) =>variant.id === selectedVariantId)
 
      // Toggle the correct label
      if (selectedVariant && selectedVariant.inventory_quantity > 0) {
        unavailableLabel.style.display = 'none'
        availableLabel.style.removeProperty('display')
      } else {
        unavailableLabel.style.removeProperty('display')
        availableLabel.style.display = 'none'
      }
    }

  if (!form) return
 
    variantSelect.addEventListener('change', updateStockMessage)
    Array.from(form.elements).forEach(e => {
      e.addEventListener('change', updateStockMessage)
    })
  })